exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-5e2d9564]{width:100%;background-color:#f4f4f5}.footer[data-v-5e2d9564]:nth-child(n+2){margin-top:36px}.footer[data-v-5e2d9564]::after{display:block;width:100%;height:1px;background-image:linear-gradient(to right, #ff8214, #ffa014);content:\"\"}.footer__body[data-v-5e2d9564]{position:relative;display:flex;width:1140px;align-items:center;justify-content:center;padding:12px 10px;margin:0 auto}.footer__copyright[data-v-5e2d9564]{color:#2e2e3b;font-size:.7692307692rem;line-height:1}.footer__button[data-v-5e2d9564]{position:fixed;bottom:0;left:50%;width:115px;margin-left:calc((1140px / 2) - 115px)}", ""]);

// exports
